// extracted by mini-css-extract-plugin
export default {"locationInfoSection":"styles_locationInfoSection__aJjBe","dataSection":"styles_dataSection__KWIaD","header":"styles_header__zb272"};